import TEMPLATE_URL from 'emun.vendor/parser/vendor-parser.htm'
import controller from 'emun.vendor/parser/vendor-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'Vendor Bulk Pad...',
    subTitle = 'Enter Vendor IDs separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onCustomerSelected = NOOP,
    onCustomerDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onVendorSelected,
                onVendorDeselected,
                view,
            })
        }
    }).result;